import {db} from "../firebase-config";
import {addDoc, collection} from "firebase/firestore";
import {Transaction} from "../domain/Transaction";
import {Recurrence} from "../domain/Recurrence";
import {sanitizeDataForFirestore} from "./sanitizeDataForFirestore";
import {computePersistableState} from "../service/computePersistableState";

export const saveSnapshot = async (transactions: Transaction[], recurrences: Recurrence[], repayments: Array<null>) => {
  const {oneTimeTransactions, persistedRecurringTransactions} = computePersistableState(transactions, recurrences)

  const sanitizedOneTimeTransactions = sanitizeDataForFirestore(oneTimeTransactions)
  const sanitizedEditedRecurringTransactions = sanitizeDataForFirestore(persistedRecurringTransactions)
  const sanitizedRecurrences = sanitizeDataForFirestore(recurrences)
  const sanitizedRepayments = sanitizeDataForFirestore(repayments)

  try {
    await addDoc(collection(db, 'snapshots'), {
      timestamp: new Date().toISOString(),
      oneTimeTransactions: sanitizedOneTimeTransactions,
      editedRecurringTransactions: sanitizedEditedRecurringTransactions,
      recurrences: sanitizedRecurrences,
      repayments: sanitizedRepayments
    })
  } catch (error) {
    console.error('Failed to save snapshot', error)
  }
}

export const removeUncheckedRecurringTransactions = (transactions: Transaction[]) => {
  return transactions.filter(
    t => !t.recurrenceId || t.checked || (t.amountModifications?.length ?? 0) > 0,
  )
}

